(function () {
  'use strict';

  angular
      .module('tfc.retailer.Purchase')
      .factory('PurchaseAttribute', PurchaseAttribute);

  // @ngInject
  function PurchaseAttribute($q, Api, BrandReports, BRAND_URL) {

    return {
      selectedBrandKey : selectedBrandKey,
      getAttributeHierarchies : getAttributeHierarchies,
      getSalesByAttribute : getSalesByAttribute,
      getSalesByConsumerAge : getSalesByConsumerAge,
      getSalesByConsumerBmi : getSalesByConsumerBmi,
      getPurchaseAttributeFilters: getPurchaseAttributeFilters
    };

    function selectedBrandKey(brandKey) {
      return BrandReports.selectedBrandKey(brandKey);
    }

    function getAttributeHierarchies(brandKey, transaction, region) {
      return Api.get(Api.withEncodedPath(BRAND_URL, brandKey) + '/report/purchase/attributes/meta', {
        cache: true,
        params: {region: region, transaction: transaction}
      }).then(_.property('data'));
    }

    function getSalesByAttribute(brandKey, department, category, attribute, transaction, region){
      return Api.get(Api.withEncodedPath(BRAND_URL, brandKey) + '/report/purchase/attributes/summary', {
        cache : true,
        params : {department : department, category : category,
          attribute : attribute, transaction: transaction, region: region}
      }).then(_.property('data.sales'));
    }

    function getSalesByConsumerAge(brandKey, department, category, attribute, attributeValue, transaction, region){
      return Api.get(Api.withEncodedPath(BRAND_URL, brandKey) + '/report/purchase/attributes/age', {
        cache : true,
        params : {department : department, category : category,
          attribute : attribute, attributeValue : attributeValue,
          transaction: transaction, region: region}
      }).then(_.property('data.sales'));
    }

    function getSalesByConsumerBmi(brandKey, department, category, attribute, attributeValue, transaction, region){
      return Api.get(Api.withEncodedPath(BRAND_URL, brandKey) + '/report/purchase/attributes/bmi', {
        cache : true,
        params : {department : department, category : category,
          attribute : attribute, attributeValue : attributeValue,
          transaction: transaction, region: region}
      }).then(_.property('data.sales'));
    }

    function getPurchaseAttributeFilters(brandKey){
      return Api.get(Api.withEncodedPath(BRAND_URL, brandKey) + '/report/purchase/attributes/filters', {cache : true}).then(_.property('data'));
    }

  }

})();
